import Home from './views/Home'
import HomeOld from './views/HomeOld'
import Package from './views/Package'
import PackageOld from './views/PackageOld'
import PersonalInfo from './views/PersonalInfo'
import Summary from './views/Summary'
import Agreement from './views/Agreement'
import VerifyOTP from './views/VerifyOTP'
import Payment from './views/Payment'
import PaymentSuccess from './views/PaymentSuccess'
import Callback from './views/Callback'
import NewCallback from './views/NewCallback'
import ErrorUw from './views/ErrorUw'
import ErrorCommon from './views/ErrorCommon'
import ErrorPayment from './views/ErrorPayment'
import ErrorMaintenance from './views/ErrorMaintenance'

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/home-old',
    name: 'HomeOld',
    component: HomeOld
  },
  {
    path: '/packages',
    name: 'Package',
    component: Package
  },
  {
    path: '/packages-old',
    name: 'PackageOld',
    component: PackageOld
  },
  {
    path: '/personal-info',
    name: 'PersonalInfo',
    component: PersonalInfo
  },
  {
    path: '/summary',
    name: 'Summary',
    component: Summary
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement
  },
  {
    path: '/verify-otp',
    name: 'VerifyOTP',
    component: VerifyOTP
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: PaymentSuccess
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  {
    path: '/new-callback',
    name: 'NewCallback',
    component: NewCallback
  },
  {
    path: '/error-uw',
    name: 'ErrorUw',
    component: ErrorUw
  },
  {
    path: '/error-common',
    name: 'ErrorCommon',
    component: ErrorCommon
  },
  {
    path: '/error-payment',
    name: 'ErrorPayment',
    component: ErrorPayment
  },
  {
    path: '/error-ma',
    name: 'ErrorMaintenance',
    component: ErrorMaintenance
  },
  { redirect: true, path: '/', pathTo: '/home', name: 'Home' }
]
export default routes;
